<template>
    <section class="table-pager">
        <div class="Table">
            <slot name="header" />
            <vnodes
                :nodes="$slots.default"
                :pageNumber="pager.pageNumber"
                :pageSize="pager.pageSize"
            />
        </div>
        <PagerControl
            v-if="$slots.default && $slots.default.length"
            :length="$slots.default.length"
            v-model="pager"
        />
    </section>
</template>

<script>
import PagerControl from './PagerControl';

const MIN_PAGE_SIZE = 24;
export default {
    props: {
        pageSize: {
            type: Number,
            default: MIN_PAGE_SIZE,
        },
        pageNumber: {
            type: Number,
            default: 1,
        },
    },
    data() {
        return {
            pager: {},
            // const injection
            MIN_PAGE_SIZE: MIN_PAGE_SIZE,
            // default init
            selectedPageSize: this.pageSize,
        };
    },
    components: {
        PagerControl,
        Vnodes: {
            functional: true,
            render: (h, ctx) => {
                const { pageNumber, pageSize, nodes } = ctx.props;
                if (nodes) {
                    return nodes.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
                }
                return null;
            },
        },
    },
};
</script>

<style lang="scss">
.table-pager {
    margin: 0 30px;
}

$border-color: #9ca5b0;
$border-header-color: #6c3e91;

@mixin card-display {
    border: 1px solid $border-color;
    border-top: 5px solid $border-header-color;
    border-radius: 5px;
    background-color: #ffffff;
}

// http://inlehmansterms.net/2014/10/11/responsive-tables-with-flexbox/
.Table {
    $light-color: #ffffff;
    $dark-color: #f2f2f2;
    $row-bottom-border: #f1f1f2;
    $md: 600px;
    $row-margin: 30px;
    $row-padding: 15px;

    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    font-size: 1rem;
    line-height: 1.5;

    @media (min-width: $md) {
        // display borders for all rows and header
        @include card-display();
    }

    // .Table-header
    &-header {
        // default hidden
        display: none;

        @media (min-width: $md) {
            // display with bottom-border
            font-weight: 700;
            padding: 20px $row-margin;
            display: flex;
            flex-flow: row nowrap;
            border-bottom: 1px solid $border-color;
        }
    }

    // .Table-row
    &-row {
        position: relative;

        @media (max-width: $md) {
            // display borders for all rows (no header) as table
            @include card-display();
            // add spacing between cards
            margin-bottom: 15px;
        }

        @media (min-width: $md) {
            margin: 0 $row-margin;
            padding: $row-padding 0;
            display: flex;
            align-items: center;
            flex-flow: row nowrap;
            border-bottom: 1px solid $row-bottom-border;

            &:last-child {
                @media (min-width: $md) {
                    border-bottom: none;
                }
            }
        }

        // .Table-row-item
        &-item {
            display: flex;
            flex-flow: row nowrap;
            flex-grow: 1;
            flex-basis: 0;
            padding: 0.5em;
            word-break: break-word;

            &:before {
                content: attr(data-header);
                width: 30%;
                font-weight: 700;
            }

            @media (min-width: $md) {
                padding: 0.5em;

                &:before {
                    content: none;
                }
            }

            @media (max-width: $md) {
                align-items: center;
            }

            &.row--xs {
                flex-grow: 0.2;
            }
        }

        &:not(:hover) {
            .row-actions {
                display: none;
            }
        }

        .row-actions {
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);

            .row-actions--icon {
                height: 23px;
                width: 23px;
                border: 1px solid #6c3e91;
                border-radius: 5px;
                background-color: #6c3e91;
                color: #ffffff;
                padding: 7px;
                margin-left: 9px;
                cursor: pointer;

                &.alert {
                    border: 1px solid #ea5b0c;
                    background-color: #ea5b0c;
                }
            }
        }
    }
}
</style>
